import React from "react";
import ReactMarkdown from "react-markdown";
import PageHeader from "../../components/shared/PageHeader";
import useMediaQuery from "../../components/shared/useMediaQuery";

const secondTnc = `## Terms and Conditions

These terms and conditions outline the rules and regulations for the use of RSC's Website and Discord Server. (https://rs-chain.com)

By accessing this website and/or Discord server, we assume you accept these terms and conditions in full. Do not continue to use RSC's website or Discord server if you do not accept all of the terms and conditions stated on this page.

The following terminology applies to these Terms and Conditions, Privacy Statement, and Disclaimer Notice, as well as any or all Agreements: "Client," "You," and "Your" refer to you, the person accessing this website or Discord server and accepting the Company's terms and conditions. "The Company," "Ourselves," "We," "Our," and "Us" refer to our Company, RSC. "Party," "Parties," or "Us" refer to both the Client and ourselves, or either the Client or ourselves. All terms refer to the offer, acceptance, and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner, whether by formal meetings, digital communications, or any other means, for the express purpose of meeting the Client's needs in respect to the provision of the Company's stated services/products, in accordance with and subject to the prevailing law of the United States. Any use of the above terminology or other words in the singular, plural, capitalization, and/or he/she or they are taken as interchangeable and therefore as referring to the same.

---

### 1. Use of Our Services

1.1 By using RSC's website and Discord server, you confirm that you are at least 18 years old or have permission from a legal guardian to engage in transactions with us.
1.2 You agree to provide accurate information when requesting quotes, selling items, and conducting any transactions on our platform.
1.3 Any attempt to exploit the system, manipulate prices, or engage in fraudulent activity will result in an immediate ban and potential legal action.

### 2. Item Listings and Sales

2.1 All items sold through RSC must be authentic, accurately described, and in the agreed condition.
2.2 It is your responsibility to ensure the items are shipped within the agreed-upon timeframe.
2.3 We reserve the right to refuse or cancel any transaction if we suspect fraudulent behavior or misrepresentation of items.

### 3. Payments and Payouts

3.1 Payments for accepted items will be processed within the timeframe stated at the time of agreement.
3.2 Payouts will be made via the chosen payment method, and any fees associated with the transaction may be deducted.
3.3 Chargebacks, disputes, or fraudulent activity involving payments will result in suspension and potential legal action.

### 4. Prohibited Items

4.1 The sale of stolen, counterfeit, restricted, or prohibited items is strictly forbidden.
4.2 Any attempt to sell such items will result in immediate termination of your account and potential legal consequences.
4.3 RSC reserves the right to update the list of prohibited items at any time.

### 5. Shipping & Tracking

5.1 You must ship items using the correct method and provide valid tracking information.
5.2 Failure to ship items as agreed may result in delays, loss of payment, or banning from our platform.
5.3 RSC is not responsible for lost, damaged, or undelivered shipments unless otherwise specified.

### 6. User Conduct & Community Guidelines

6.1 Respectful communication is required at all times within the Discord server and platform.
6.2 Harassment, threats, hate speech, or any form of misconduct will result in an immediate ban.
6.3 Advertising or promoting third-party services without permission is prohibited.

### 7. Disputes & Resolutions

7.1 If a dispute arises, users must contact RSC Support for resolution before taking external action.
7.2 RSC reserves the right to make final decisions on disputes based on available evidence.
7.3 If legal action is required, disputes will be resolved under the jurisdiction of Texas.

### 8. Account Termination

8.1 RSC reserves the right to suspend or terminate accounts at our sole discretion for violations of these terms.
8.2 Users who are banned or suspended will forfeit any pending transactions or unpaid balances.
8.3 Appeals for reinstatement may be considered but are not guaranteed.

### 9. Cookies

9.1 RSC uses cookies to enhance user experience, improve site functionality, and analyze traffic.
9.2 By using our website, you consent to the use of cookies in accordance with our Privacy Policy.
9.3 You can manage or disable cookies through your browser settings, but some features of our platform may not function properly without them.

### 10. Modifications to Terms & Conditions

10.1 RSC reserves the right to update these terms at any time without prior notice.
10.2 Continued use of the platform after modifications indicates acceptance of the new terms.

### 11. Contact Information

For questions or concerns regarding these Terms and Conditions, please contact us at:\\
Email: [support@rs-chain.com](mailto:support@rs-chain.com)

---

By using RSC's website and Discord server, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
`;

const TncPage = () => {
  const isMobile = useMediaQuery("(max-width: 640px)");
  const cardStyle = {
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: isMobile ? "4px 16px" : "26px 28px",
    background: "linear-gradient(180deg, rgba(255,255,255,0.02), transparent)",
    overflowWrap: "anywhere",
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 760,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? 10 : 24,
      }}
    >
      <PageHeader
        title="Terms & Conditions"
        subtitle="Review RSC's terms of service."
      />

      <div style={cardStyle}>
        <div className="member-markdown">
          <ReactMarkdown>{secondTnc}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default TncPage;
